import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M10 2v7.31", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 9.3V1.99", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8.5 2h7", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 9.3a6.5 6.5 0 1 1-4 0", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M5.52 16h12.96", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "FlaskRound";
const FlaskRound = memo(themed(Icon));
export {
  FlaskRound
};
//# sourceMappingURL=flask-round.js.map
